import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/lib/session';
import { homeFor } from '@/lib/nav.config';

export function RoleGate({ role, children }) {
  const { user, isLoggedIn } = useSession();
  const location = useLocation();

  if (!isLoggedIn || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (role && user.role !== role) {
    return <Navigate to={homeFor(user.role)} replace />;
  }

  return children;
}
